// Angular Files
import { NgModule } from '@angular/core';
import { PlatformModule } from '@angular/cdk/platform';

// Teller Online Shared Files
import { ServicesModule } from './services/services.module';
import { ComponentsModule } from './components/components.module';

@NgModule({
    imports: [
        ServicesModule, 
        ComponentsModule,
        PlatformModule
    ],
    exports: [
        ServicesModule,
        ComponentsModule,
        PlatformModule
    ]
})
export class SharedModule { }